// ThreadForm
import ClassNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { getTranslator } from '../locales';
import {
  submit as threadsSubmit,
  select as threadSelect,
} from '../redux/actions/threadsAction';
import {
  warning
} from '../redux/actions/alertAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    locale: Store.settings.locale,
    labels: {
      ADD_DETAILS_TO_QUESTION: t.t('Optional: additional details can be added below'),
      ASK_A_NEW_QUESTION: t.t('Ask a new question'),
      ASK_QUESTION_WARNING: t.t('Ensure that your question has not already been asked by someone else.'),
      ASK_YOUR_QUESTION_HERE: t.t('Ask your question here'),
      CANCEL: t.t('Cancel'),
      DESCRIPTION_PLACEHOLDER: t.t('Add additional information to your question here…'),
      POST_MY_QUESTION: t.t('Post my question'),
      QUESTION_PLACEHOLDER: t.t('Write your question here…'),
      QUESTION_TITLE_REQUIRED_LENGTH: t.t('You need to provide a question title between 20 and 120 characters.'),
      SELECT: t.t('Select…'),
      SPECIFY_WHAT_YOUR_QUESTION_IS_ABOUT: t.t('Please choose a category for your question'),
    },
    luser: Store.luser,
    categories: Store.filters.categories,
    isAskFormOpened: Store.chat.isAskFormOpened,
    nbThreads: Store.threads.list.length,
    selectedThread: Store.threads.selectedThread,
  };
})

export default class ThreadForm extends React.Component {
  constructor() {
    super();
    this.state = { question: '', 'description': '', 'categoryId': 0 };
  }

  handleSubmit(e) {
    e.preventDefault();

    const question = _.trim(this.state.question);

    if (question == '') {
      return;
    }

    if (question.length < 20 || question.length > 120){
      this.props.dispatch(warning(this.props.labels.QUESTION_TITLE_REQUIRED_LENGTH));
      return;
    }

    if (this.state.description.length > 2000) {
      return;
    }

    if (!this.state.categoryId || this.state.categoryId == 0) {
      this.props.dispatch(warning(this.props.labels.SPECIFY_WHAT_YOUR_QUESTION_IS_ABOUT));
      return;
    }

    const thread = {
      question,
      description: _.trim(this.state.description),
      categoryId: this.state.categoryId
    }

    this.setState({ question: '', 'description': '', 'categoryId': '1' });
    this.props.dispatch(threadsSubmit(thread));
  }

  keyDownHandler(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  }

  changeHandler(e) {
    var stateObject = function() {
      var returnObj = {};
      returnObj[this.target.name] = _.replace(
        _.upperFirst(_.trimStart(this.target.value)),
        /\n{2,}/ig,
        '\n\n'
      );
      return returnObj;
    }.bind(e)();
      this.setState(stateObject);
  }

  handdleToggleForm() {
    if (!this.props.isAskFormOpened) {
      this.props.mobilePanelChange('thread_form');
    } else if (this.props.selectedThread && this.props.selectedThread.id) {
      this.props.mobilePanelChange('messages');
    } else {
      this.props.mobilePanelChange('welcomehelper');
    }
  }

  /**
   * This function try to compute a string length with encoded emoji
   * @param {string} str
   * @return {int}
   */
  getLen(str) {
    // This regex purpose is to isolate emoji unicode char
    const regex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
    let length = 0;
    let regexMatch = true

    while (regexMatch !== null) {
      regexMatch = regex.exec(str);

      if (regexMatch === null) {
        break;
      }
      length += encodeURI(regexMatch).length;
    }
    length += str.replace(regex, '').length;
    return length;
  }

  render() {
    const t = getTranslator();

    // TODO
    // Consolidate this with the rest of the labels.
    // Could not do it cause the inputs (title + details) are not in the
    // store and cannot be passed as props using a mapStateToProps function.
    const dynamicLabels = {
      TITLE_CHAR_MAX: t.t(
        '%{max_chars} characters max. (%{num_chars} left)', {
          max_chars: 120,
          num_chars: 120 - this.getLen(this.state.question)
        }
      ),
      DETAILS_CHAR_MAX: t.t(
        '%{max_chars} characters max. (%{num_chars} left)', {
          max_chars: 2000,
          num_chars: 2000 - this.getLen(this.state.description)
        }
      )
    };

    const itemClass = {
      'shown': this.props.isAskFormOpened,
      [this.props.mobilePanelClassName('thread_form')]: true
    };

    return(
      <div className={ClassNames(itemClass)}>
        <div className='heading brandedColor_bg'>
          <i className='pe-7s-comment'></i>
          <h2>{this.props.labels.ASK_A_NEW_QUESTION}</h2>
          <div className='clear'></div>
        </div>
        <div className='inner-content'>
          <form>
            {
              (() => {
                if (this.props.nbThreads >= 5) {
                  return <h4 className='brandedColor_color'><i className='pe-7s-attention'></i> {this.props.labels.ASK_QUESTION_WARNING}</h4>
                }
              })()
            }
            <div className='form-group'>
              <label htmlFor='question'>{this.props.labels.ASK_YOUR_QUESTION_HERE}</label>
              <input
                id='question'
                type='text'
                name='question'
                maxLength='120'
                onKeyDown={this.keyDownHandler.bind(this)}
                onChange={this.changeHandler.bind(this)}
                value={this.state.question}
                className='form-control'
                placeholder={this.props.labels.QUESTION_PLACEHOLDER}
                tabIndex='1'
                spellCheck='true'
                autoCorrect='on'
                required='required'
                autoFocus={true}
              />
              <em>{dynamicLabels.TITLE_CHAR_MAX}</em>
              <div className='clear'></div>
            </div>
            <div className='form-group'>
              <label htmlFor='comment'>{this.props.labels.ADD_DETAILS_TO_QUESTION}</label>
              <textarea
                id='comment'
                name='description'
                onChange={this.changeHandler.bind(this)}
                value={this.state.description}
                className='form-control'
                placeholder={this.props.labels.DESCRIPTION_PLACEHOLDER}
                maxLength='2000'
                tabIndex='2'
                spellCheck='true'
                autoCorrect='on'
              ></textarea>
              <em>{dynamicLabels.DETAILS_CHAR_MAX}</em>
            </div>
            <div className='form-group'>
              <label htmlFor='category'>{this.props.labels.SPECIFY_WHAT_YOUR_QUESTION_IS_ABOUT}</label>
              <select
                name='categoryId'
                value={this.state.categoryId}
                id='category'
                onChange={this.changeHandler.bind(this)}
                className='form-control'
                tabIndex='3'
              >
                <option
                  key={'s_cat_null'}
                  value='0'
                >{this.props.labels.SELECT}</option>
                {
                  this.props.categories.map(category => {
                    return (
                      <option
                        key={`s_cat'${category.id}`}
                        value={category.id}
                      >{category.name}</option>
                    );
                  })
                }
              </select>
            </div>
            <div className='actions'>
              <button
                type='button'
                className='btn btn-secondary fleft'
                onClick={this.handdleToggleForm.bind(this)}
              >{this.props.labels.CANCEL}</button>
              <input
                type='submit'
                value={this.props.labels.POST_MY_QUESTION}
                onClick={this.handleSubmit.bind(this)}
                tabIndex='4'
                className='btn btn-primary brandedColor_bg brandedColorLight_border' />
            </div>
          </form>
          <div className='clear'></div>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ThreadForm.jsx